<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">utilities</p>
        <h1 class="dg-header">Sizing</h1>
        <p>Easily make an element as wide or as tall (relative to its parent) with our width and height utilities.</p>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            <p class="h3 dg-subheader">A few Examples</p>
            <div class="w-25 p-2 bg-light">Width 25%</div>
            <div class="w-50 p-2 my-3 bg-light">Width 50%</div>
            <div class="w-75 p-2 my-3 bg-light">Width 75%</div>
            <div class="w-100 p-2 bg-light">Width 100%</div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Code</p>
            <pre class="code-sample">
              <code class="html">
&lt;div class="w-25"&gt; ... &lt;/div&gt;
&lt;div class="w-50"&gt; ... &lt;/div&gt;
&lt;div class="w-75"&gt; ... &lt;/div&gt;
&lt;div class="w-100"&gt; ... &lt;/div&gt;</code>
            </pre>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col">
            <p class="h3 dg-subheader">Variants / Modifiers</p>
            <ul>
              <li class="var-sample mb-2">.h-25</li>
              <li class="var-sample mb-2">.h-50</li>
              <li class="var-sample mb-2">.h-75</li>
              <li class="var-sample mb-2">.h-100</li>
            </ul>
            <p>You can also use <span class="code">max-width: 100%;</span> and <span class="code">max-height: 100%;</span> utilities as needed (<span class="code">.mw-100</span> and <span class="code">.mh-100</span>).</p>
          </div>
        </div>
       <!--  <div class="row mt-4">
          <div class="col">
            <p class="h4 dg-subheader">Accessibility</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Commodi ad doloremque rem quasi voluptatum temporibus voluptates non unde, veritatis molestias velit impedit iste tenetur officiis et quae nisi facilis atque!</p>
          </div>
        </div> -->
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
export default {
  name: "Sizing"
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Sizing.vue